<script lang="ts" setup>
import SkrButton from '@/components/button/SkrButton.vue'

defineProps<{
  loading?: boolean
}>()

const emit = defineEmits<{
  accept: []
}>()

const { isChargebeeTrial } = storeToRefs(useBusinessStore())

const { t } = useI18n()

const isShown = defineModel<boolean>()

const title = computed(() => {
  return isChargebeeTrial.value ? t('business.plan.change_to_starter') : t('business.plan.change_to_free')
})

const text = computed(() => {
  return isChargebeeTrial.value ? t('dialog.business.change_to_starter.text') : t('dialog.business.change_to_free.text')
})
</script>

<template>
  <v-dialog v-model="isShown" max-width="510">
    <v-card data-cy="freePlanDowngradeDialog">
      <v-card-title class="text-h5"> {{ title }}? </v-card-title>
      <v-card-text>
        <div class="pb-4">
          <p class="mb-4">{{ text }}</p>
          <ul v-if="!isChargebeeTrial">
            <li>{{ t('dialog.business.downgrade.item_1') }}</li>
            <li>{{ t('dialog.business.downgrade.item_2') }}</li>
            <li>{{ t('dialog.business.downgrade.item_3') }}</li>
          </ul>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <skr-button size="xl" color="info" variant="outlined" @click="isShown = false">
          {{ t('global.no_thanks') }}
        </skr-button>
        <v-spacer />
        <skr-button
          size="xl"
          color="error"
          data-cy="confirm_downgrade_button"
          variant="elevated"
          :loading="loading"
          @click="emit('accept')"
        >
          {{ title }}
        </skr-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
